import type { ReactNode } from 'react';

import './StickyActionBar.scss';

/** Пропсы липкой строки действий StickyActionBar. */
export interface StickyActionBarProps {
  /** левый слот — итог/сводка; strong внутри выделяется как сумма (20px, $primary) */
  content?: ReactNode;
  /** правый слот — главные действия (кнопки) */
  actions?: ReactNode;
  /** показывать только на узких экранах (<1050px) — когда на широких уже есть прилипающая боковая панель */
  narrowOnly?: boolean;
  className?: string;
}

/**
 * Липкая строка внизу прокручиваемой области: слева итог (content), справа
 * главные действия (actions). narrowOnly прячет бар на широких экранах и
 * включает при <1050px — например, когда на десктопе рядом уже прилипает
 * боковая панель. Выделено из мастера ШМ (tfw-sticky-total) в коллекцию ui.
 *
 * Отрицательные боковые/нижний маржины компенсируют стандартный паддинг
 * родителя 1rem (modal-body) — бар растягивается вплотную к краям.
 */
const StickyActionBar = (props: StickyActionBarProps) => {
  const { content, actions, narrowOnly, className } = props;

  return (
    <div className={ [
      'sticky-action-bar',
      narrowOnly ? 'sticky-action-bar-narrow' : '',
      className || '',
    ].filter(Boolean).join(' ') }
    >
      { content && <div className='sticky-action-bar-content'>{ content }</div> }
      { actions && <div className='sticky-action-bar-actions'>{ actions }</div> }
    </div>
  );
};

export default StickyActionBar;
